import React, { ReactNode } from "react";

import { Col, Row } from "components";

type AdminSectionProps = {
  headline: string;
  description?: string;
  extra?: ReactNode;
};

export const AdminSection = ({ headline, description, extra }: AdminSectionProps) => (
  <Row justify="space-around" align="middle">
    <Col sm={24} md={16}>
      <h3 style={{ margin: "1rem 0 0.5rem 0" }}>{headline}</h3>
      {description && (
        <p style={{ maxWidth: "768px" }} className="grey-text">
          {description}
        </p>
      )}
    </Col>
    <Col sm={24} md={8} className="right">
      <div className="admin-extra">{extra}</div>
    </Col>
  </Row>
);

export default AdminSection;
